import { gukApi } from '../api'
import { setEvents, setCurrent, setLoading } from '../store/guk/slice'


export const getEvents = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.getEvents(params)
    dispatch(setEvents(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getEvent = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.getEvent(eventId)
    dispatch(setCurrent(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const createEvent = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.createEvent(data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const updateEvent = (eventId, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.updateEvent(eventId, data)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const deleteEvent = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    await gukApi.deleteEvent(eventId)
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const openEventRegistration = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.openRegistration(eventId)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}

export const getEventResults = (eventId) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await gukApi.getEventResults(eventId)
    return response.data
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}
